import styled, { css } from 'styled-components'
import themeGet from '@styled-system/theme-get'

type ContainerProps = {
  secondary?: boolean
}

const shouldForwardProp = (prop: string) => !['secondary'].includes(prop)

const containerSecondaryCss = ({ secondary }: ContainerProps) =>
  secondary &&
  css`
    background-color: ${themeGet('colors.primary.dark')};
  `

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<ContainerProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  min-height: 100dvh;

  ${containerSecondaryCss}
`
